import { db } from '@/components/Firebase_Conn'

import Vue from 'vue'


const getDefaultState = () => {
  return {
    listini: [],
    active: undefined,
    hasChanged: false
    //dalla variabiel hasChanged capisco se 
    //il listino è stato cambiato manualmente dall'utente (true)
    //o se si è attivato all'apertura dell'ordine (false)
    //mi serve saperlo per evitare di sovrascrivere gli l_prezzo
    //già presenti in un ordine presalvato
    //considerando che nel frattempo le regole potrebbero essere cambiate
  }
}


// initial state
const state = getDefaultState()
 

// getters
const getters = {
  // eslint-disable-next-line no-undef
  listini: state => state.listini,
  active: state => state.active,
  hasChanged: state => state.hasChanged
}

// actions
const actions = {
  // in futuro questo dovrà puntare al nodo listino strippato.
  get({ commit, state }, payload) {
    state.listini = []
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + payload.source
    this.databaseOps.db.ref(pointer).on('value', function (snapshot) {
      var arr = []
      snapshot.forEach((itemSnap) => {
        const item = itemSnap.val()
        arr.push(item)
      })
      commit('set', arr)
      console.log('attiva: ' + payload.idActiveList)
      commit('setActive', payload.idActiveList)
      
    })
  },
  remove({ commit, state }, payload) {
    // elimina qualsiasi listino dall array ricambi/accessori
    // implementare fonte dell array da trattare
    payload.ricambi.forEach(function (ricambio, index) {
      Object.keys(ricambio).forEach(function (key) {
        if (key.substring(0, 2) === 'r_' || key.substring(0, 2) === 'l_') { Vue.delete(ricambio, key) }
      })
    })
  },
  apply({ commit, state, dispatch }, payload) {
    // RIMUOVO LISTINI PRECEDENTI
    // console.log(' REIMPLEMENTARE --Regola più recente rispetto all attuale')
    if (state.active !== undefined) {
      payload.ricambi.forEach(function (ricambio, index) {
        if (ricambio.path !== undefined && state.active !== null) {
          state.active.regole.forEach(function (regola, index) {
            ricambio.path.forEach(function (path, index) {
              if (path[regola.parent] !== undefined) {
                if (path[regola.parent] === regola.id) {
                  Vue.set(ricambio, 'l_prezzo', regola.l_prezzo)
                  if (
                    regola.id === ricambio.id &&
                    regola.l_prezzo !== 0 &&
                    regola.l_prezzo !== -0
                  ) {
                    Vue.set(ricambio, 'regola_specifica', true)
                  }
                }
              }
            })
          })
        } else console.log('Path ricambio non definito')
      })
    } else {
      // se listino attivo null/undefined vuol dire
      // che nessun listino selezionato quindi lo rimuovo
      dispatch('remove', { 'ricambi': payload.ricambi })
    }
    return payload.ricambi
  }
}

// mutations
  const mutations = {
  initModule(state) {
    Object.assign(state, getDefaultState())
  },
  changed(){
    state.hasChanged = true
  },
  reset(state) {
    state.listini = []
  },
  set(state, obj) {
    state.listini = obj
  },
  setActive(state, id) {
    state.active = state.listini.find(x => x.id === id)
   //console.log ('eccolo: ' + state.active.titolo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
